<template>
  <div>
    <b-table
      :id="id"
      small
      hover
      table-class="pie-table"
      thead-class="hidden-header"
      :items="items"
      :fields="fields"
      class="mb-0"
      :tbody-tr-class="rowClass"
    >
      <template v-slot:cell(colourKey)="data">
        <div
          :style="{ background: data.item.color }"
          class="colorKey align-baseline"
        />
      </template>
    </b-table>
  </div>
</template>

<script lang="ts">
import { BvTableFieldArray } from 'bootstrap-vue'
import Vue, { PropType } from 'vue'
import Component from 'vue-class-component'

import { GraphItem } from '@/components/public/GraphTable/GraphTableTotal.vue'

const props = {
  items: {
    type: Array as PropType<GraphItem[]>,
    required: true,
  },
  showPercentages: {
    type: Boolean,
    default: false,
  },
  highlightedRow: {
    type: String,
    default: null,
  },
  id: {
    type: String,
    required: true,
  },
}

@Component
export default class PieTable extends Vue.extend({ props }) {
  get fields () {
    const fields: BvTableFieldArray = [
      {
        key: 'colourKey',
        class: 'align-middle',
      },
      { key: 'title' },
      { key: 'formatted' },

    ]
    if (this.showPercentages) {
      fields.push({
        key: 'percentage',
        formatter: (value) => {
          const percent = this.$typedStore.visualisationApp.numericFormatting(value, {
            style: 'percent',
            maximumSignificantDigits: 2,
          })
          return '(' + percent + ')'
        },
      })
    }
    return fields
  }

  rowClass (item: { title: string }) {
    if (item.title === this.highlightedRow) {
      return 'highlighted-row'
    }
  }
}
</script>

<style >
/* NB Not a scoped style block */
.hidden-header {
  display: none;
}

.table {
  margin-bottom: 0 !important;
}

.highlighted-row > td {
  background-color: rgba(229, 229, 229, 0.4);
}

.table-hover tbody tr:hover td {
  background-color: rgba(229, 229, 229, 0.4);
}

.pie-table > tbody tr:first-child td {
  border-top-color: rgba(0,0,0,0);
}

</style>

<style scoped>

.colorKey {
  border-radius: 50%;
  width: 1rem;
  height: 1rem;
  border: 1px solid #666;
  align-items: middle;
}

</style>
